
	import {
		Component,
		Vue,
		Prop,
		Watch,
		Emit,
		Mixins
	} from "vue-property-decorator";
    import vselect3 from "vselect3";
    import { namespace } from "vuex-class";
    import { Guard, GuardType, PatrolZone, AlarmFilter, UploadedGuard } from '@/store/dispatch/types';
    import { Select } from "@sureview/vuejs-sv-dropdown";
    import EditableTableData from "@/components/table/EditableTableData.vue";

    const Dispatch = namespace('dispatch');

    @Component({
         components: {
            "v-select-3": vselect3,
            "editable-td": EditableTableData
		}
     })
    export default class BulkUploadRow extends Vue {
        @Dispatch.State(state => state.GuardTypes) guardTypes: GuardType[];
        @Dispatch.State(state => state.AlarmFilters) alarmFilters!: AlarmFilter[];

        @Prop({ type: Object, default: () => {} }) private value: UploadedGuard;
        @Prop({type: Array, default: () => [] }) availableZones: PatrolZone[];
        @Prop(Number) rowIndex: number;

        // Adds an 'Unassigned' item to the list of AlarmQueue filters 
        public get alarmQueueFilters(): AlarmFilter[] {
            return [
                { alarmQueueFilterID: 0, title: 'Unassigned' }, ...this.alarmFilters
            ];
        }

        // Handler for when a callsign changes
        private revalidateCallsigns(): void {
            // Emit an event so the table can revalidate all call signs
            this.$emit("callsignChanged", null);
        }

        // Handler for the delete click
        private deleteRow(): void {
             // Emit an event so the row can be deleted from the array of uploaded data
            this.$emit("rowDeleted", this.rowIndex);
        }

        //////
        // Methods to handle when fields in the table are updated and finish editting
        // used by the 'editable-td' 
        /////

        // Call sign
        private callsignFinishEdit(finishEdit: Function): void {
            finishEdit();
        }

        // Guard Type
        // Gets the Guard Type and sets fake details if the title isn't valid
        public get assignedGuardType(): number {
            const selectedGuardType:GuardType = this.guardTypes.filter(gt => gt.title == this.value.dispatchGuardTypeTitle)[0];
            if (selectedGuardType) {
                return selectedGuardType.dispatchGuardTypeID;
            }
            else {
                return 0;
			}
		}

        private updateGuardType(guardTypeId:number, finishEdit: Function): void {
            const selectedGuardType: GuardType = this.guardTypes.filter(gt => gt.dispatchGuardTypeID == guardTypeId)[0];
            this.value.dispatchGuardTypeValid = true;
            this.value.dispatchGuardTypeTitle = selectedGuardType.title;
            this.value.dispatchGuardTypeID = selectedGuardType.dispatchGuardTypeID;
            finishEdit();
        }

        private guardTypeFinishEdit(): void {
            // Check if the value is now valid
            if (this.guardTypes.filter(gt => gt.title == this.value.dispatchGuardTypeTitle).length > 0) {
                this.value.dispatchGuardTypeValid = true;
            }
            else {
                this.value.dispatchGuardTypeValid = false;
            }
        }

        // AlarmQueue Filter
        // Gets the AlarmQueueFilter and sets fake details if the title isn't valid
        public get assignedAlarmQueueFilter(): number {
            const selectedAlarmQueueFilter:AlarmFilter = 
                this.alarmFilters.filter(af => af.title == this.value.alarmQueueFilterTitle)[0];
            if (selectedAlarmQueueFilter) {
                return selectedAlarmQueueFilter.alarmQueueFilterID;
            }
            else {
                return null;
            }
		}

        private updateAlarmQueueFilter(alarmQueueFilterId:number, finishEdit: Function): void {
            const selectedAlarmQueueFilter = this.alarmQueueFilters.filter(af => af.alarmQueueFilterID == alarmQueueFilterId)[0]
            this.value.alarmQueueFilterValid = true;
            this.value.alarmQueueFilterID = selectedAlarmQueueFilter.alarmQueueFilterID;
            this.value.alarmQueueFilterTitle = selectedAlarmQueueFilter.title;
            finishEdit();
        }

        private alarmQueueFilterFinishEdit(): void {
            if (this.alarmQueueFilters.filter(af => af.title == this.value.alarmQueueFilterTitle).length > 0 ) {
                this.value.alarmQueueFilterValid = true;
            } else {
                this.value.alarmQueueFilterValid = false;
            }
        }

        // Patrol Zone
        // Gets the PatrolZone details out of the dictionary
        public get assignedPatrolZone(): PatrolZone {
            // If the Patrol zone was invalid on load it will be null
            // so create a dummy one with an Id of 0 and a title as per the upload
            // This will be overwritten when a valid zone is selected
            if (!this.value.patrolZones) {
                return {patrolZoneID:0, title:this.value.patrolZoneTitle};
            } else {
                const patrolZoneId: number = Number(Object.keys(this.value.patrolZones)[0]);
                return this.availableZones.filter(pz => pz.patrolZoneID == patrolZoneId)[0];
            }       
        }

        private updatePatrolZone(patrolZoneId:number, finishEdit: Function): void {
            // Get the zone selected
            const selectedPatrolzone: PatrolZone = this.availableZones.filter(pz => pz.patrolZoneID == patrolZoneId)[0];
            
            // Update the guard (row)
            this.value.patrolZones = { [selectedPatrolzone.patrolZoneID]: selectedPatrolzone.title}
            
            // Mark the value as valid
            this.value.patrolZoneValid = true;
            // Set the patrolZoneTitle that is used outside of the patrolZones object
            this.value.patrolZoneTitle = 
                this.availableZones.filter(pz => pz.patrolZoneID == patrolZoneId).map(pz => pz.title)[0];
            finishEdit();
        }

        private patrolZoneFinishEdit():void {
            if (this.availableZones.filter(pz => pz.title == this.value.patrolZoneTitle).length > 0 ) {
                this.value.patrolZoneValid = true;
            } else {
                this.value.patrolZoneValid = false;
            }
        }
    }
